import React from "react";

import { StatusBanner } from "@/components/feature/StatusBanner";

const AppointmentSuccess = () => (
  <StatusBanner tone="success" title="Einladung versendet" className="mt-[1.2rem]">
    Die Einladung wurde an alle ausgewählten Teilnehmer versendet. Bitte schliessen Sie die Terminerstellung mit „Senden" ab.
  </StatusBanner>
);

export default AppointmentSuccess;
